// removed by extract-text-webpack-plugin
module.exports = {"alertBox":"_3rQuG"};